"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Promise = window.Promise;
var _default = Promise;
exports.default = _default;
module.exports = exports.default;